import httpClient from '@emmacare/common/api/httpClient'

import { USER_PROFILE } from 'src/constants'

export default {
  getUserProfile() {
    return httpClient.get(USER_PROFILE)
  }
}
